/**
 * 提携会社一覧。
 *
 * 求職者の登録情報を提供する先の会社です。第三者提供の同意を有効にするには
 * 「提供先を特定できる状態」である必要があるため、このページの掲載内容は
 * functions/.env の CLIENT_EMAILS（実際の配信先）と必ず一致させてください。
 *
 * 会社を追加・削除したら、CLIENT_EMAILS も同時に更新すること。
 */
export interface Partner {
  /** 会社名（登記上の名称） */
  name: string;
  /** 有料職業紹介事業許可番号・労働者派遣事業許可番号など */
  license: string;
  /** 所在地 */
  address: string;
  /** 会社サイト（任意） */
  url?: string;
}

export const PARTNERS: Partner[] = [
  // 例：
  // {
  //   name: "株式会社〇〇",
  //   license: "有料職業紹介事業 23-ユ-000000 ／ 労働者派遣事業 派23-000000",
  //   address: "愛知県名古屋市〇区〇〇1-2-3",
  //   url: "https://example.co.jp",
  // },
];
